import { PaymentMethodModel } from "../data";

export interface PaymentMethodsPayloadModel {
  paymentMethods: PaymentMethodModel[];
}
